<template>
  <div class="subtitle text-xs text-grey uppercase tracking-wider font-heavy">
    {{ subtitle }}
  </div>
</template>

<script>
export default {

  name: 'BaseSubtitle',
  props: {
    subtitle: { type: String, required: true },
  },
};
</script>
